<template>
  <div class="flex">
    <PerPageSelect v-if="show_per_page" />
    <div class="grow"></div>
    <div class="flex flex-wrap gap-1" v-if="total_pages > 1">
      <RouterLink
        v-for="(page, index) in visible_pages"
        :key="index"
        class="btn min-w-14"
        :class="{
          'btn-primary': current_page === page,
          'btn-disabled': page === '...',
        }"
        onclick="document.activeElement.blur()"
        :to="{
          name: $route.name,
          query: {
            ...$route.query,
            [page_query_key]: page,
          },
        }"
      >
        {{ page }}
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import PerPageSelect from "./PerPageSelect.vue";
import { router } from "@/router/router";

const props = withDefaults(
  defineProps<{
    total_pages: number;
    page_query_key?: string;
    show_per_page?: boolean;
    pages_around_current?: number; // Số trang hiển thị xung quanh trang hiện tại
  }>(),
  {
    page_query_key: "page",
    show_per_page: true,
    pages_around_current: 1,
  },
);

const current_page = computed(() => {
  const page = Number(router.currentRoute.value.query[props.page_query_key]);
  return Number.isInteger(page) && page > 0 ? page : 1;
});

const visible_pages = computed(() => {
  const pages: (number | string)[] = [];
  const totalPages = Math.ceil(Math.max(1, props.total_pages ?? 0));
  const pagesAroundCurrent = props.pages_around_current;

  // Thêm trang đầu tiên
  pages.push(1);

  // Thêm dấu ... nếu khoảng cách giữa trang đầu tiên và trang hiện tại lớn hơn 1
  if (current_page.value > pagesAroundCurrent + 2) {
    pages.push("...");
  }

  // Thêm các trang xung quanh trang hiện tại
  const start = Math.max(2, current_page.value - pagesAroundCurrent);
  const end = Math.min(totalPages - 1, current_page.value + pagesAroundCurrent);

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  // Thêm dấu ... nếu khoảng cách giữa trang hiện tại và trang cuối cùng lớn hơn 1
  if (current_page.value < totalPages - (pagesAroundCurrent + 1)) {
    pages.push("...");
  }

  // Thêm trang cuối cùng nếu nó không phải là trang đầu tiên
  if (totalPages > 1) {
    pages.push(totalPages);
  }

  return pages;
});
</script>
